<modal-placeholder>
  <div class="video__container position-relative">
    <div class="video__close position-absolute" (click)="close()">
      <svg class="img-fluid" width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="23" cy="23" r="23" fill="black"/>
        <line x1="30.9958" y1="16.1474" x2="16.004" y2="30.8527" stroke="white" stroke-width="3"/>
        <line x1="30.8526" y1="30.9959" x2="16.1473" y2="16.0041" stroke="white" stroke-width="3"/>
      </svg>        
    </div>
    <iframe width="100%" height="100%"
      src="https://www.youtube.com/embed/mVYWGmFLcoY"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      sandbox="allow-scripts allow-same-origin allow-presentation" 
      allowfullscreen></iframe>
  </div>
</modal-placeholder>